import {
  SequenceViewer,
  type SequenceViewerTab,
} from "@components/sequence-viewer";
import { createFileRoute, Navigate, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { useViewerFile } from "./-viewerFileContext";

const searchSchema = z.object({
  searchId: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/_data/view/$fileId/searches")({
  validateSearch: searchSchema,
  component: SearchesRoute,
});

function SearchesRoute() {
  const file = useViewerFile();
  const navigate = useNavigate();
  const { searchId } = Route.useSearch();

  function handleTabChange(tab: SequenceViewerTab) {
    if (tab === "sequence") {
      navigate({ to: "/view/$fileId", params: { fileId: file.id } });
    } else if (tab === "features") {
      navigate({
        to: "/view/$fileId/features",
        params: { fileId: file.id },
      });
    } else if (tab === "primers") {
      navigate({ to: "/view/$fileId/primers", params: { fileId: file.id } });
    } else if (tab === "history") {
      navigate({ to: "/view/$fileId/history", params: { fileId: file.id } });
    }
  }

  function handleSelectSearch(id: string) {
    navigate({
      to: "/view/$fileId/searches",
      params: { fileId: file.id },
      search: { searchId: id },
    });
  }

  function handleDeselectSearch() {
    navigate({
      to: "/view/$fileId/searches",
      params: { fileId: file.id },
      search: {},
    });
  }

  if (file.type !== "GnomuxSequence") {
    return <Navigate to="/view/$fileId" params={{ fileId: file.id }} replace />;
  }

  return (
    <SequenceViewer
      sequenceId={file.content as string}
      tab="searches"
      onTabChange={handleTabChange}
      selectedSearchId={searchId ?? null}
      onSelectSearch={handleSelectSearch}
      onDeselectSearch={handleDeselectSearch}
    />
  );
}
